import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Unassigned extends ChemComponent {
	constructor(props) {
		super(props);

		var search = this.copyDefaultSearch();

		// if there is storage
		if (typeof(Storage) !== 'undefined') {
			var storedSearch = localStorage.getItem('Jobtrack_Jobs_search');
			if (storedSearch) {
				storedSearch = JSON.parse(storedSearch);
				this.mergeObject(search, storedSearch);
				search = storedSearch;
				//this.quoteStringArrays(initApplicationList.ajax.data.search);
			}
		}
		
		var jobListInit = this.copyTable(jobList);
		jobListInit.ajax.data = {
			search: search
		};

		this.state = {
			search: search,
			jobSearch: this.copyJobSearch(),
			jobList: jobListInit,
			showSearch: false,
			searchCount: null,
			renderKey: 0
		};
	}
	
	copyDefaultSearch() {
		// start with from date of 90 days ago
		var from90Days = new Date();
		from90Days.setDate(from90Days.getDate() - 90);
		
		var search = {
			JOB_ID: null,
			JOB_LABEL: '',
			EXTERNAL_JOBNO: '',
			SHOP_ID: null,
			JOB_REF: '',
			JOB_COMMENT: '',
			STATUS_COMMENT: '',
			CREATED_FROM: this.dateTimeToMVC(from90Days),
			CREATED_TO: null,
			CUSTOMER_NAME: null,
			PI_ROLE: [],
			PI_NAME: '',
			STATUS_ID: 0,
			PAGE_SEARCH: '',
			ORDER_BY: ['JOB_ID desc']
		};
		
		return search;
	}
	
	copyJobSearch() {
		var jobSearchCopy = this.copyColumns(jobSearch);
		
		if (this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 3) {
			// find job id column
			var jobIdCol = this.findColumnByAccessor(jobSearchCopy.columns, 'JOB_LABEL');
			
			// restrict jobs to this user's PIs
			jobSearchCopy.columns[jobIdCol].options.search =
				{ Attribute: 'PI_ROLE', Operator: 'in', LongList: this.props.user.jobtrack.piRoleIDs };			

			// find customer name column
			var custNameCol = this.findColumnByAccessor(jobSearchCopy.columns, 'CUSTOMER_NAME');
			var custSearch = [];

			// auth level 4 can only see customers 1 and 2
			custSearch.push(this.generatePipedIDClause('CUSTOMER_RANK', [1,2]));

			// auth level 4 can only see customers from jobs that are owned by their PI's
			if (this.props.user.jobtrack.piRoleIDs.length > 0) {
				custSearch.push(this.generatePipedIDClause('JOB_PI_ID', this.props.user.jobtrack.piRoleIDs));
			}
			
			// restrict customers to this user's PIs' jobs
			jobSearchCopy.columns[custNameCol].options.search = { Operator: 'and', Children: custSearch };
			
			// find speedtype column
			var speedtypeCol = this.findColumnByAccessor(jobSearchCopy.columns, 'SPEEDTYPE');
			
			// auth level 4 can only see speedtypes from their PI's jobs
			if (this.props.user.jobtrack.piRoleIDs.length > 0) {
				jobSearchCopy.columns[speedtypeCol].options.search =
					this.generatePipedIDClause('PI_ROLE', this.props.user.jobtrack.piRoleIDs);
			}
		}
		
		return jobSearchCopy;
	}
	
	generatePipedIDClause(colName, idList) {
		var likeClauses = [];
		
		for (var i = 0; i < idList.length; i++) {
			likeClauses.push({ Attribute: colName, Operator: 'like', StringValue: '%|' + idList[i] + '|%' });
		}
		
		return ({ Operator: 'or', Children: likeClauses });
	}
	
	addJob() {
		this.props.navigate('/Jobtrack/Jobs/new');
	}
	
	editJob(jobId) {
		this.props.setJobEditable(true);
		this.props.navigate('/Jobtrack/Jobs/' + jobId);
	}
	
	viewJob(jobId) {
		this.props.setJobEditable(false);
		this.props.navigate('/Jobtrack/Jobs/' + jobId);
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search }, () => {
			if (accessor === 'PAGE_SEARCH') window.find(value);
		});
	}

	onNewSearch(event) {
		this.mergeState({
			search: this.copyDefaultSearch(),
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		if (newOrderBy) search.ORDER_BY = newOrderBy;
		
		// copy search again so that when we modify PI_ROLE
		// it will only affect the table
		var newJobList = this.copyTable(jobList);
		newJobList.ajax.data = { search: this.copyObject(search) };
		
		// convert PI_ROLE to array of integers and add to table
		var piRoleIDs = [];
		if (!this.isEmpty(newJobList.ajax.data.search.PI_ROLE)) {
			var strPIRoleIDs = newJobList.ajax.data.search.PI_ROLE.split('|');
			for (var i = 0; i < strPIRoleIDs.length; i++) {
				if (this.isNumeric(strPIRoleIDs[i])) piRoleIDs.push(+strPIRoleIDs[i]);
			}
		}
		newJobList.ajax.data.search.PI_ROLE = piRoleIDs;
		
		this.mergeState({
			search: search,
			jobList: newJobList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		}, () => {
			if (typeof(Storage) !== 'undefined') {
				localStorage.setItem('Jobtrack_Jobs_search', JSON.stringify(this.state.search));
			}
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'Jobs',
			columns: exportColumns,
			search: this.state.search
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Job List</div>
						{this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={this.state.jobSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						  {this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						  }
						  <Button id="newSearch" style={{ marginRight: '10px' }} variant="warning" type="button" className="float-end" onClick={(event) => this.onNewSearch(event)}>New Search</Button> 
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Jobs' table={this.state.jobList}
				    order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const jobSearch = [
	{ Header: 'Job ID', valueAccessor: 'JOB_ID', accessor: 'JOB_LABEL', type: 'dropdown', row: 0, col: 0,
		options: { value: 'JOB_ID', label: 'JOB_LABEL', entity: 'RECHARGES.JOB_DROPDOWN_VW', order: 'JOB_ID' }},
	{ Header: 'External Job #', accessor: 'EXTERNAL_JOBNO', row: 0, col: 1 },
	{ Header: 'Description', accessor: 'JOB_REF', row: 1, col: 0 },
	{ Header: 'Job Comment', accessor: 'JOB_COMMENT', row: 1, col: 1 },
	{ Header: 'Status Comment', accessor: 'STATUS_COMMENT', row: 1, col: 2 },
	{ Header: 'Entered From', accessor: 'CREATED_FROM', type: 'date', row: 2, col: 0 },
	{ Header: 'Entered To', accessor: 'CREATED_TO', type: 'date', row: 2, col: 1 },
	{ Header: 'Customer', accessor: 'CUSTOMER_NAME', type: 'select', row: 2, col: 2,
		options: { value: 'CUSTOMER_NAME', label: 'CUSTOMER_NAME', entity: 'RECHARGES.CUSTOMER_SELECT_AGG_VW', order: 'CUSTOMER_NAME' }},
	{ Header: 'PI', accessor: 'PI_ROLE', labelAccessor: 'PI_NAME', type: 'select', row: 3, col: 0,
		options: { value: 'PI_ROLE', label: 'PI_NAME', entity: 'RECHARGES.JOB_PI_SELECT_AGG_VW', order: 'PI_NAME' }},
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', type: 'dropdown', row: 3, col: 1,
		options: { value: 'SPEEDTYPE', label: 'SPEEDTYPE', entity: 'RECHARGES.JOB_SPEEDTYPE_SELECT_VW', order: 'SPEEDTYPE' }},
	{ Header: 'Status', accessor: 'STATUS_ID', type: 'select', row: 3, col: 2,
		options: { value: 'STATUS_ID', label: 'STATUS_NAME', entity: 'RECHARGES.JOB_STATUS_SELECT_VW', order: 'STATUS_NAME' }},
	{ Header: 'Updated From', accessor: 'MODIF_FROM', type: 'date', row: 4, col: 0 },
	{ Header: 'Updated To', accessor: 'MODIF_TO', type: 'date', row: 4, col: 1 },
	{ Header: 'Page Search', accessor: 'PAGE_SEARCH', row: 4, col: 2 }
];

const jobList = {
	ajax: { 
		url: '/JobTrack/GetUnassignedJobs',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addJob()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editJob(props.row.values.JOB_ID)} /> },
		{ Header: 'Job ID', accessor: 'JOB_ID', width: 60,
			Cell: props => <HashLink onClick={() => props.parent.viewJob(props.value)}>{props.value}</HashLink> },
		{ Header: 'Description', accessor: 'JOB_REF', width: 300 },
		{ Header: 'Entered', accessor: 'CREATED_DISPLAY', width: 125 },
		{ Header: 'Customer', accessor: 'CUSTOMER_NAME', width: 125 },
		{ Header: 'PI', accessor: 'PI_NAME', width: 125 },
		{ Header: 'Speedtype', accessor: 'SPEEDTYPES', width: 125 },
		{ Header: 'Status', accessor: 'STATUS_NAME', width: 125 },
		{ Header: 'Updated', accessor: 'UPDATED_DISPLAY', width: 125 }
	]
};

const exportColumns = [
	{ Header: 'Job ID', accessor: 'JOB_ID', width: 12 },
	{ Header: 'Description', accessor: 'JOB_REF', width: 60 },
	{ Header: 'Entered', accessor: 'CREATED_DISPLAY', width: 25 },
	{ Header: 'Customer', accessor: 'CUSTOMER_NAME', width: 25 },
	{ Header: 'PI', accessor: 'PI_NAME', width: 25 },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPES', width: 25 },
	{ Header: 'Status', accessor: 'STATUS_NAME', width: 25 },
	{ Header: 'Updated', accessor: 'UPDATED_DISPLAY', width: 25 }
];

export default withRouter(Unassigned);
